import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCompanySettings } from 'modules/settings/api';

export const useQueryCompanySettings = () => {
  const { data, isError, isLoading } = useQuery(QUERY_KEYS.SETTINGS_PROFILE_COMPANY_SETTINGS, () =>
    getCompanySettings(),
  );

  return {
    data,
    isLoading,
    isError,
  };
};
